<template>
  <main class="main">
    <section class="banner bgs-cover bgp-c">
      <div class="w-1000 h-100p m-a p-r">
        <h1 class="m-0 fs-50 fw-700 c-fff c-c p-a">After-Sales Policy</h1>
      </div>
    </section>
    <!-- banner:end -->
    <div class="crumb w-1000 m-a d-f jc-fs ai-c ff-asl fs-16">
      <a class="c-666" href="/">Home</a><span class="c-ccc"></span><a class="c-666" href="support">Support Center</a
      ><span class="c-ccc"></span><a class="c-666 ff-as">After-Sales Policy </a>
    </div>
    <section class="aftersalespolicy mb-120">
      <div class="w-1000 m-a">
        <h2 class="m-0 fs-40 ta-c">AFTER-SALES POLICY</h2>
        <div class="policy-content lh-15 c-666 fs-16">
          <Collapse v-model="value1">
            <Panel name="1">
              <div class="content-title d-f jc-sb ai-c fs-20 c-p c-000">
                <strong>FJDynamics After-sales Policy</strong>
              </div>
              <p slot="content" class="content-box">
                Stay worry-free, knowing that FJDynamics Technical Support Team is strategically aligned worldwide to
                upport your maintenance and service needs. We offer a range of services from installation, calibration,
                and maintenance. FJDynamics local support team can be found in many locations and countries around the
                world. We also offer online resources to help support your product. If any issue occurs, please feel
                free to contact us by <a class="c-000" href="mailto:service@fjdynamics.com">service@fjdynamics.com</a>.
              </p>
            </Panel>
          </Collapse>
          <!-- <div class="content-title d-f jc-sb ai-c fs-20 c-p c-000">
            <strong>FJDynamics After-sales Policy</strong><i @click="openTabs" class="d-ib triangle-icon triangle-icon-000"></i>
          </div>
          <div class="content-box" v-show="showContent">
            <p>
              Stay worry-free, knowing that FJDynamics Technical Support Team is strategically aligned worldwide to
              support your maintenance and service needs.
            </p>
            <p>
              We offer a range of services from installation, calibration, and maintenance. FJDynamics local support
              team can be found in many locations and countries around the world.
            </p>
            <p>
              We also offer online resources to help support your product. If any issue occurs, please feel free to
              contact us by <a class="c-000" href="mailto:service@fjdynamics.com">service@fjdynamics.com</a>.
            </p>
          </div> -->
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  export default {
    data() {
      return {
        showContent: false,
        value1: '1'
      }
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .policy-content .content-title {
    // border-bottom: 1px solid #eee;
  }
  .policy-content .content-title:first-child {
    border-color: transparent;
  }
  .policy-content .content-box {
    background-color: #f7f7f7;
  }
  .policy-content .content-title strong {
    flex: 1;
    font-weight: 500;
  }
  :deep(.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header) {
    height: 80px;
  }
  :deep(.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header > i) {
    font-size: 30px;
    position: absolute;
    top: 20px;
    right: 0;
    // transform: rotate(-90deg);
  }
  :deep(.ivu-collapse) {
    background: none;
    border: none;
  }
  :deep(.ivu-collapse > .ivu-collapse-item.ivu-collapse-item-active > .ivu-collapse-header) {
    border-bottom: 1px solid #ffffff;
  }
  @media screen and (min-width: 769px) {
    .w-1000 {
      width: 1000px;
    }
    main {
      margin-top: 3.958vw;
    }
    .banner {
      height: 3.6rem;
      background-image: url('@/assets/images/support/support_banner.jpg');
    }
    .crumb {
      padding: 68px 0 100px;
    }
    .crumb a:hover {
      color: #333;
    }
    .triangle-icon-000 {
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h20v20H0z'/%3E%3Cfilter color-interpolation-filters='auto' id='b'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 8.8L8.648.385a1.581 1.581 0 0 1 .001 2.267l-7.483 7.28L0 8.8zm1.173-1.14l7.585 7.377a1.583 1.583 0 0 1-.001 2.27L.01 8.793l1.165-1.134-.002.002z' fill='%23515151' fill-rule='nonzero' transform='rotate(90 6.538 11.923)' filter='url(%23b)'/%3E%3C/g%3E%3C/svg%3E");
      width: 20px;
      height: 20px;
    }
    .tr-180 {
      transform: rotate(180deg);
    }
    .aftersalespolicy h2 {
      margin-bottom: 70px;
    }
    .policy-content a:hover {
      text-decoration: underline;
    }
    .policy-content .content-title {
      padding: 15px 0;
    }
    .policy-content .content-box {
      padding: 10px 15px;
      margin-bottom: 20px;
    }
    .white-box {
      padding: 5px 10px;
    }
  }
</style>
